import {writable} from 'svelte/store';

const data = writable({
    notifications: [],
});

export const steps = writable({
    currentStep: 1,
    previousStep: null,
    nextStep: null,
    nextStepAllowed: false
});

export const reservation = writable({
    parkId: '',
    eventType: '',
    numJumpers: 6,
    maxJumpers: 50,
    jumpDate: null,
    timeSlot: null,
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    socks: 0,
    duration: 1,
    marketingEmails: false,
    conditions: false,
    readableJumpDate: null,
    readableParkName: '',
    readableEventTypeName: '',
    celebrantIndex: 1,
    celebrants: [{'id': 1, 'name': '', 'age': null, 'gender': ''}],
    openingDate: null,
    openingDateDisplay: null
});


export default data;
